module.exports = __webpack_public_path__ + "static/media/400024_01.1759ac68.png";